<template>
    <div>
        <Card>
            <p slot="title">{{t.name}}</p>
            <Row class="margin-top-10">
                <Col style="text-align:left;" span="4">
                    <Select v-model.trim="searchItem.division" @on-change="handleSearchChange($event)"
                            :placeholder="msgUtil.placeholderSelected(t.menu.catalog)">
                        <Option :value="item.division" :key="item.division" v-for="item in divisionList">
                            {{item.name}}
                        </Option>
                    </Select>
                </Col>
                <Col style="text-align:left;" span="8">
                    <Button @click="handleSearchChange(searchItem.division)">
                        <Icon type="md-refresh" size="16"/>
                    </Button>
                </Col>
                <Col style="text-align:right;" span="12">
                    <!-- name 是路由名，参考的@/router/organization/dept.js的名 -->
                    <Button to="./add">
                        <Icon type="md-add" size="16"/>
                        {{msgUtil.message.action.add}}
                    </Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <zk-table
                    ref="table"
                    sum-text="sum"
                    index-text="#"
                    :data="data"
                    :loading="loading"
                    :columns="columns"
                    :show-header="props.showHeader"
                    :show-row-hover="props.showRowHover"
                    :show-index="props.showIndex"
                    :tree-type="props.treeType"
                    :is-fold="props.isFold"
                    :expand-type="props.expandType"
                    :selection-type="props.selectionType">
                    <!--<template slot="likes" scope="scope">
                        {{ scope.row.likes.join(',') }}
                    </template>-->
                </zk-table>
            </Row>
        </Card>
        <Modal v-model.trim="delModal" width="360" :mask="true" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{t.message.delConfirmTitle}}</span>
            </p>
            <div style="text-align:center">
                <p>{{t.message.delConfirm}}</p>
            </div>
            <div slot="footer">
                <Button size="large" @click="handleDeleteCancel">
                    {{msgUtil.message.action.cancel}}
                </Button>
                <Button type="error" size="large" :loading="delModalLoading" @click="handleDelete">
                    {{msgUtil.message.action.delete}}
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { delAll, getTreeMenuList } from '@/api/menu';
import { Button, ButtonGroup, Icon, Tag } from 'iview';
import ZkTable from '@/components/Table/Table';

export default {
    name: 'organization_menu_list',
    components: {
        ZkTable,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderSortOrder = (row, column) => {
            if (row.type === 'c') {
                return '';
            }
            return <Tag type="border">{row.sortOrder}</Tag>;
        };
        const renderType = (row, column) => {
            if (row.type === 'c') {
                return '';
            }
            let color = '';
            let text = '';
            if (row.type === 'm') {
                color = 'volcano';
                text = t.menu.typeMenu;
            } else if (row.type === 'b') {
                color = 'magenta';
                text = t.menu.typeButton;
            } else {
                color = 'gray';
                text = t.menu.catalog;
            }
            return <Tag color={color}>{text}</Tag>;
        };

        const renderIcon = (row, column) => {
            return <Icon type={row.icon} size={column.size} />;
        };

        const renderStatus = (row, column) => {
            if (row.type === 'c') {
                return '';
            }
            let color = 'default';
            let text = '';
            if (row.status === '1') {
                color = 'green';
                text = t.menu.statusOpen;
            } else {
                color = 'red';
                text = t.menu.statusClose;
            }
            return <Tag color={color}>{text}</Tag>;
        };
        /*<Button type="error" size="small" on-click={$event => this.handleDelete(row.id)}>*/
        const renderAction = (row, column) => {
            if (row.type === 'c') {
                return '';
            }
            return (
                <ButtonGroup>
                    <Button type="primary" size="small" to={'./edit/' + row.id}>
                        {msgUtil.message.action.edit}
                    </Button>
                    <Button type="error" size="small" on-click={$event => this.openDelModal($event, row)}>
                        {msgUtil.message.action.delete}
                    </Button>
                </ButtonGroup>
            );
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            props: {
                showHeader: true,
                showRowHover: true,
                showIndex: false,
                treeType: true,
                isFold: false,
                expandType: false,
                selectionType: false,
            },
            searchItem: {
                division: '1',
            },
            delModal: false,
            delModalLoading: false,
            delIdList: [],
            data: [],
            divisionList: [{ name: t.menu.frontEndName, division: '1' }, { name: t.menu.backEndName, division: '2' }],
            typeList: [{ name: t.menu.typeMenu, type: 'm' }, { name: t.menu.typeButton, type: 'b' }],
            columns: [
                {
                    label: '',
                    prop: '',
                    width: '30px',
                },
                {
                    label: t.table.menuName,
                    prop: 'name',
                    width: '260px',
                    tooltip: true,
                },
                {
                    label: t.table.icon,
                    prop: 'icon',
                    align: 'left',
                    width: '72px',
                    type: 'icon',
                    size: 20,
                    render: renderIcon,
                },
                {
                    label: t.table.url,
                    prop: 'url',
                    minWidth: '125px',
                    tooltip: true,
                },
                {
                    label: t.table.permit,
                    prop: 'permit',
                    minWidth: '70px',
                    tooltip: true,
                },
                {
                    label: t.table.sortOrder,
                    prop: 'sortOrder',
                    width: '80px',
                    type: 'tag',
                    render: renderSortOrder,
                },
                {
                    label: t.table.type,
                    prop: 'type',
                    width: '100px',
                    type: 'tag',
                    render: renderType,
                },
                {
                    label: t.table.status,
                    prop: 'status',
                    width: '84px',
                    type: 'tag',
                    render: renderStatus,
                },
                {
                    label: msgUtil.message.action.name,
                    prop: 'action',
                    type: 'button',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    computed: {},
    methods: {
        async handleSearchChange(val) {
            this.loading = true;
            //得到后台所有菜单展示
            const treeMenuList = await getTreeMenuList({
                division: val,
            });
            this.data = treeMenuList.menus;
            this.loading = false;
        },
        // 删除取消
        async openDelModal(event, row) {
            let idList = [row.id];
            let Find = (element, list) => {
                idList.push(element.id);
                if (element.children.length > 0) {
                    FindChildren(element.children, list);
                }
            };
            let FindChildren = (children, list) => {
                children.forEach(ele => Find(ele, list));
            };
            if (row.children.length > 0) {
                FindChildren(row.children, idList);
            }
            this.delIdList = idList;
            this.delModal = true;
        },
        // 删除取消
        async handleDeleteCancel() {
            this.delModalLoading = false;
            this.delModal = false;
            this.delIdList = [];
        },
        // 删除
        async handleDelete() {
            await delAll(this.rowSelect(this.delIdList));
            await this.handleSearchChange(this.searchItem.division);
            this.delModalLoading = false;
            this.delModal = false;
            this.delIdList = [];
        },
        // 行选择
        rowSelect(selection) {
            return selection.map(p => {
                return { id: p };
            });
        },
    },
    async mounted() {
        await this.handleSearchChange(this.searchItem.division);
    },
};
</script>

<style scoped>
</style>
